// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-table[data-v-3edfe110]{padding:0 20px;box-sizing:border-box}.baikeCat .el-select[data-v-3edfe110]{width:48%;float:left}", ""]);
// Exports
module.exports = exports;
